import isMatch from 'lodash/isMatch'

import { ContactPerson } from '../../../../../types/contactPerson'
import { getContactPersonsWithoutEmptyPrimaryContact } from '../../../../../utils/getContactPersonsWithoutEmptyPrimaryContact'
import { isContactPersonMainFieldsFilled } from '../../../utils/contactPersons/contactPersonValidation'

interface AddNewPrimaryContactToContactPersonsProps {
  contactPersons: ContactPerson[]
  currentPrimaryContact: {
    email?: string
    firstName?: string
    lastName?: string
  }
  newPrimaryContact: ContactPerson
}

export const addNewPrimaryContactToContactPersons = ({
  contactPersons = [],
  currentPrimaryContact,
  newPrimaryContact,
}: AddNewPrimaryContactToContactPersonsProps): ContactPerson[] => {
  const { email, firstName, lastName } = currentPrimaryContact

  const currentPrimaryContactHasData = isContactPersonMainFieldsFilled(email, firstName, lastName)
  const hadPrimaryContactInList = contactPersons.some((contact) => contact.isPrimary)
  const contactPersonsWithoutEmptyPrimaryContact = getContactPersonsWithoutEmptyPrimaryContact(contactPersons)

  const updatedContacts = contactPersonsWithoutEmptyPrimaryContact.map((contact) => {
    if (contact.isPrimary && currentPrimaryContactHasData) {
      return { ...contact, email, firstName, lastName, isPrimary: false }
    }
    return { ...contact, isPrimary: false }
  })

  if (!hadPrimaryContactInList && currentPrimaryContactHasData) {
    const contactAlreadyExists = updatedContacts.some((contact) => isMatch(contact, { email, firstName, lastName }))

    if (!contactAlreadyExists) {
      updatedContacts.push({ email, firstName, lastName, isPrimary: false })
    }
  }

  updatedContacts.unshift({ ...newPrimaryContact, isPrimary: true })

  return updatedContacts
}
